<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-list nav>
        <v-list-item-group class="pb-4">
          <v-list-item @click="goTo('/Monitoring')">
            <v-icon color="primary darken-2" class="pr-2"
              >icon-alertadis-map</v-icon
            >
            <v-list-item-content>
              <v-list-item-title class="text-wrap menu-item-title"
                >Monitoramento</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <!--Permitir acesso em produção quanto este item estiver finalizado! -->
          <!--v-list-item class="mb-4" @click="goTo('/Historical')"></v-list-item-->
          <v-list-item class="mb-4" @click="goTo('/Historical')">
            <v-icon color="primary darken-2" size="28" class="pr-2"
              >icon-alertadis-file-search-alt</v-icon
            >
            <v-list-item-content>
              <v-list-item-title class="text-wrap menu-item-title"
                >Dados históricos</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="mb-4" @click="goTo('/LightningHistory')">
            <v-icon color="primary darken-2" size="28" class="pr-2"
              >icon-alertadis-flash</v-icon
            >
            <v-list-item-content>
              <v-list-item-title class="text-wrap menu-item-title"
                >Histórico de raios</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="isAdmin()"></v-divider>
          <div class="mt-2" v-if="isAdmin()">
            <span class="adm-title">ADMINISTRADOR</span>
          </div>

          <v-list-item
            class="mb-4"
            @click="goTo('/management')"
            v-if="isAdmin()"
          >
            <v-icon color="primary darken-2" size="28" class="pr-2"
              >icon-alertadis-users-alt</v-icon
            >
            <v-list-item-content>
              <v-list-item-title class="text-wrap menu-item-title"
                >Gerenciar usuários</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    isProduction: process.env.NODE_ENV === "production",
  }),
  methods: {
    goTo(route) {
      this.$router.push(route).catch(() => {});
    },
    isAdmin() {

      let roles = this.$store.getters.currentUser.attributes.roles;
      const substring1 = "AlertaDIS_SUPER_USER";
      const substring2 = "AlertaDIS_ADMIN";

      if (!Array.isArray(roles)) {
        roles = [roles];
      }

      const match = roles.find((element) => {
        if (element.includes(substring1) || element.includes(substring2)) {
          return true;
        }
      });

      if (match !== undefined) return true;

      return false;
    },
  },

};
</script>


<style scoped>
.adm-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-darken2);
}

.menu-item-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-darken2);
}
</style>
